module.exports = __webpack_public_path__ + "static/media/lycan.d5ec5f29.png";